import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { IStrapiImage } from '../interfaces/strapi/strapi_image.interface';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  constructor(
    private readonly http: HttpClient,
    private readonly api: ApiService
  ) {}

  public getMaintenanceStatus(): Observable<any> {
    const endpoint = `${this.api.url}/unauthenticated/maintenance`;
    return this.http.get(endpoint);
  }
}

export type MaintenanceData = {
  android_min_version: number;
  android_version: number;
  ios_min_version: number;
  ios_version: number;
  enable_web: boolean;
};

export type IMaintenanceObject = {
  title: string;
  content: string;
  logo: IStrapiImage;
};
